export const whatWeDo = [
    {
        id:'1',
        path:'/website-designing',
        pageName:'Website Designing'
    },
    {
        id:'2',
        path:'/ecommerce-webdesign-in-india',
        pageName:'E-Commerce Solutions'
    },
    {
        id:'3',
        path:'social-media-optimization-in-india',
        pageName:'Social Media Optimization'
    },
    {
        id:'4',
        path:'/digital-marketing-services-in-india',
        pageName:'Digital Marketing'
    },
    {
        id:'5',
        path:'/web-application-development',
        pageName:'Web Application Development'
    },
    {
        id:'6',
        path:'/website-maintenance-services-in-india',
        pageName:'Website Maintenance Services'
    },
    {
        id:'7',
        path:'/seo-company-in-india',
        pageName:'Search Engine Optimization'
    },
    {
        id:'8',
        path:'/dedicated-hosting',
        pageName:'Dedicated Hosting'
    },
    {
        id:'9',
        path:'/mobile-ui-ux-design',
        pageName:'UI/UX Design'
    },
    {
        id:'10',
        path:'/branding',
        pageName:'Branding'
    },
    {
        id:'11',
        path:'/ppc-services',
        pageName:'PPC Services'
    },
    {
        id:'12',
        path:'/website-development-company-in-india',
        pageName:'Website Development'
    },
    {
        id:'12',
        path:'/free-trademark-search-startups',
        pageName:'Free Trademark Search'
    }
]

export const packages = [
    {
        id:'1',
        path:'/seo-packages',
        pageName:'SEO Packages'
    },
    {
        id:'2',
        path:'/brand-packages',
        pageName:'Brand Packages'
    },
    {
        id:'3',
        path:'/ppc-packages',
        pageName:'PPC Packages'
    },
    {
        id:'4',
        path:'/digital-marketing-packages',
        pageName:'Digital Marketing Packages'
    },
    {
        id:'5',
        path:'/smo-packages',
        pageName:'SMO Packages'
    },
    {
        id:'6',
        path:'/website-design-package',
        pageName:'Website Design Packages'
    },
    {
        id:'7',
        path:'/hire-dedicated-manpower',
        pageName:'Hire Dedicated Manpower'
    },
    {
        id:'8',
        path:'/smm-packages',
        pageName:'SMM Packages'
    }
]